import FoodPrice from "../models/FoodPrice";

export const getSizeName = (foodPrice: FoodPrice) => {
    const size = foodPrice.size;

    if (size === 0) {
        return '';
    }
    else if (size === 1) {
        return "mala";
    } else if (size === 2) {
        return "srednja";
    }
    else if (size === 3) {
        return "velika";
    }
}